import React from "react";
import BaseDashboardCard from "../BaseDashboardCard";
import Box from "../Box";
import RatePieChart from "../RatePieChart";
import { AuditPrice } from "../../types/operational";

type PriceCardProps = {
  title: string;
  rateData: AuditPrice;
  isUnavailable: boolean;
  isLoading: boolean;
  openInformationModal: (title?: string) => void;
};

const PriceCard = ({ rateData, title, ...rest }: PriceCardProps) => {
  const auditPercentage = rateData?.priceAuditRate;

  return (
    <BaseDashboardCard 
      hasModal={true} 
      title={title} 
      size="small"
      importedDateTime={rateData?.importedDateTime}
      {...rest}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        py={3}
      >
        <RatePieChart auditPercentage={auditPercentage} />
      </Box>
    </BaseDashboardCard>
  );
};

export default PriceCard;
